import { render, staticRenderFns } from "./StaffScanTemperatureWithStud.vue?vue&type=template&id=d1cde9e8&scoped=true"
import script from "./StaffScanTemperatureWithStud.vue?vue&type=script&lang=js"
export * from "./StaffScanTemperatureWithStud.vue?vue&type=script&lang=js"
import style0 from "./StaffScanTemperatureWithStud.vue?vue&type=style&index=0&id=d1cde9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cde9e8",
  null
  
)

export default component.exports